export const CampaignStatuses = ['active', 'inactive'] as const
export type CampaignStatus = (typeof CampaignStatuses)[number]

export const CampaignIdentifierTypes = [
  'nric',
  'address',
  'unique_string',
] as const
export type CampaignIdentifierType = (typeof CampaignIdentifierTypes)[number]
